import { compose, hoistStatics, lifecycle, withHandlers, withState } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import StartConversation from './StartConversation';


const enhance = compose(
  connect(null, null),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
    },
  }),
  withHandlers({
  }),
);

export default hoistStatics(enhance)(StartConversation);



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/index.js